// adapted from https://github.com/glidejs/glide/issues/434#issuecomment-553628859

const VisibleClass = function (Glide, Components, Events) {
  var Component = {
    mount() {
      this.setVisibleClasses();
    },

    getVisibleRange() {
      const isFocusAtCenter = Glide.settings.focusAt === 'center';

      const before = isFocusAtCenter
        ? Math.ceil((Glide.settings.perView - 1) / 2)
        : Glide.settings.focusAt;

      const after = isFocusAtCenter
        ? before
        : Glide.settings.perView - Glide.settings.focusAt - 1;

      return {
        before,
        after,
      };
    },

    setVisibleClasses() {
      if (Glide.settings.perView > 1) {
        Components.Html.root
          .querySelectorAll('.glide__slide--visible')
          .forEach(element => {
            element.classList.remove('glide__slide--visible');
          });

        const { before, after } = this.getVisibleRange();

        for (let i = -1 * before; i <= after; i++) {
          Components.Html.slides[Glide.index + i]?.classList.add(
            'glide__slide--visible'
          );
        }
      } else {
        Components.Html.root
          .querySelectorAll('.glide__slide--visible')
          .forEach(element => {
            element.classList.remove('glide__slide--visible');
          });
        Components.Html.slides[Glide.index]?.classList.add(
          'glide__slide--visible'
        );
      }
    },
  };

  Events.on('update', () => {
    Component.setVisibleClasses();
  });

  Events.on('run', () => {
    Component.setVisibleClasses();
  });

  return Component;
};

export { VisibleClass };
